import React, { Component, ReactDOM } from 'react';
import { Form, FormControl, FormGroup, ControlLabel, Row, Col, Checkbox, Button, Tabs, Tab } from 'react-bootstrap'
import BedrijvenSearchResultTable from './BedrijvenSearchResultTable'
import BedrijvenSearchResultGoogleMaps from './BedrijvenSearchResultGoogleMaps'
import Api from './Api'

const TYPES = "types"
const SOORT = "soort"
const MATERIALS = "materials"

const FETCH_URL = 'api/companies'

class BedrijvenSearch extends Component {
    constructor() {
        super();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleSortingClick = this.handleSortingClick.bind(this);
        this.state = {
            companies: [],
            locations: [],
            value: '',
            Name: "sorting",
            City: "sorting",
            Km: '5',
            displayTable: 'none',
            emptyTable: 'none',
            pagination: {
                totalPages: 0,
                currentPage: 0,
                pageSize: 0,
                totalCount: 0,
                orderBy: "",
            },
            currentFetchUrl: FETCH_URL
        }
    }
    // Function that will be executed when the submit button is pressed
    handleSubmit(event) {
        event.preventDefault();
        var payload = {} // Data to be send in the POST request
        var typesObject = [] // Registry types object with the checkboxes marked
        var soortObject = [] // Companies object with the checkboxes marked
        var materialsObject = [] // Work areas object with the checkboxes marked
        for (var i = 0; i < event.target.elements.length; i++) {
            const e = event.target.elements[i] // Form element
            const name = e.name
            const value = e.value
            const checked = e.checked
            const className = e.className

            if (!className && checked) {
                if (name === TYPES)
                    typesObject.push(value)

                else if (name === SOORT)
                    soortObject.push(value)

                else if (name === MATERIALS)
                    materialsObject.push(value)
            }
        }

        payload[TYPES] = typesObject;
        payload[SOORT] = soortObject;
        payload[MATERIALS] = materialsObject;
        payload["Search"] = this.state.value;
        payload["Distance"] = this.state.Km;
        this.setState({ payload })

        // If there is not any checkbox marked , then:
        // DO NOT SEND DATA TO THE API
        let fields = Object.keys(payload).length === 0 && payload.constructor === Object

        if (!fields) {
            // TODO: Post payload to the API
            Api.PostTableApi(FETCH_URL, payload, this.props.history, this.handleClick).then(response => {
                if (response.pagination.totalCount === 0) {
                    this.setState({ displayTable: "none" })
                    this.setState({ emptyTable: "block" })
                } else {
                    this.setState({ displayTable: "block" })
                    this.setState({ emptyTable: "none" })
                }
                this.setState({ pagination: response.pagination })
                return response.data.json()
            }).then(objectData => {
                if (objectData !== undefined) {
                    this.setState({ companies: objectData.companies });
                    this.setState({ locations: objectData.locations });
                }
            })
        }
    }
    componentDidMount() {
        this.inputElement.click();
    }

    handleClick(e) {
        const FETCH_URL2 = e === "prev" ? this.state.pagination.prev : this.state.pagination.next;
        this.setState({ currentFetchUrl: FETCH_URL2 })
        Api.PostTableApi(FETCH_URL2, this.state.payload, this.props.history, this.handleClick).then(response => {
            if (response.pagination.totalCount === 0) {
                this.setState({ displayTable: "none" })
                this.setState({ emptyTable: "block" })
            } else {
                this.setState({ displayTable: "block" })
                this.setState({ emptyTable: "none" })
            }
            this.setState({ pagination: response.pagination })
            return response.data.json()
        }).then(objectData => {
            if (objectData !== undefined) {
                this.setState({ companies: objectData.companies });
                this.setState({ locations: objectData.locations });
            }
        })
    }
    handleSortingClick(e) {
        var newSort = this.state.pagination.orderBy.indexOf(e) >= 0 ? this.state.pagination.orderBy.indexOf("asc") >= 0 ? this.state.pagination.orderBy.replace("asc", "desc") : this.state.pagination.orderBy.replace("desc", "asc") : e + " asc";
        this.setState({ Name: "sorting" })
        this.setState({ City: "sorting" })
        this.setState({ [e]: newSort.indexOf("asc") >= 0 ? "sorting_asc" : "sorting_desc" })
        this.setState({ pagination: { ...this.state.pagination, orderBy: newSort } })
        Api.PostTableApi(FETCH_URL + "?OrderBy=" + newSort + "&PageNumber=" + this.state.pagination.currentPage + "&PageSize=" + this.state.pagination.pageSize, this.state.payload, this.props.history, this.handleClick).then(response => {
            if (response.pagination.totalCount === 0) {
                this.setState({ displayTable: "none" })
                this.setState({ emptyTable: "block" })
            } else {
                this.setState({ displayTable: "block" })
                this.setState({ emptyTable: "none" })
            }
            this.setState({ pagination: response.pagination })
            return response.data.json()
        }).then(objectData => {
            if (objectData !== undefined) {
                this.setState({ companies: objectData.companies });
                this.setState({ locations: objectData.locations });
            }
        })
    }
    handleChange(e) {
        this.setState({ value: e.target.value });
    }
    handleSelectChange(e) {
        this.setState({ Km: e.target.value });
    }
    handleKeyPress(ev) {
        if (ev.key === 'Enter') {
            ev.preventDefault()
            ev.stopPropagation();
            ev.nativeEvent.stopImmediatePropagation();
        }
    }
    render() {
        return (
            <div className="BedrijvenSearch">
                <Form horizontal onSubmit={this.handleSubmit}>
                    <FormGroup>
                        {/*<Col sm={3}>
                            <FormControl type="text"
                                value={this.state.value}
                                onChange={this.handleChange}
                                onKeyPress={this.handleKeyPress}
                                placeholder='2719EK'
                            />
                        </Col>
                        <Col sm={3}>
                            <FormControl name="Km" componentClass="select" onChange={this.handleSelectChange} required>
                                <option key="5" value="5" defaultValue>5 Km</option>,
                                <option key="10" value="10">10 Km</option>,
                                <option key="25" value="25">25 Km</option>
                                <option key="0" value="0">All</option>
                            </FormControl>
                        </Col>*/}
                        <Col sm={12}>
                            <ControlLabel>Registerconstructeur/Registerontwerper/Registertoetser:</ControlLabel>
                            <Row>
                                <Col sm={3}>
                                    <Checkbox name={TYPES} value="1" id="crc" >Registerconstructeur</Checkbox>
                                    <Checkbox name={TYPES} value="3" id="crta" >Registertoetser A</Checkbox>
                                </Col>
                                <Col sm={3}>
                                    <Checkbox name={TYPES} value="2" id="cro" >Registerontwerper</Checkbox>
                                    <Checkbox name={TYPES} value="4" id="crtb" >Registertoetser B</Checkbox>
                                </Col>
                            </Row>
                            <ControlLabel>Soort bedrijf:</ControlLabel>
                            <Row>
                                <Col sm={3}>
                                    <Checkbox name={SOORT} value="1" id="cuitvoerend" >Uitvoerend bedrijf</Checkbox>
                                </Col>
                                <Col sm={3}>
                                    <Checkbox name={SOORT} value="2" id="cingenieurs" >Ingenieursbureau</Checkbox>
                                </Col>
                            </Row>
                            <ControlLabel>Werkgebieden:</ControlLabel>
                            <Row>
                                <Col sm={3}>
                                    {Api.getWorkAreas().slice(0, 4).map((area, index) =>
                                        <Checkbox
                                            name={MATERIALS}
                                            value={index + 1}
                                            key={"area0_" + index}>
                                            {area}
                                        </Checkbox>
                                    )}
                                </Col>
                                <Col sm={3}>
                                    {Api.getWorkAreas().slice(4, 8).map((area, index) =>
                                        <Checkbox
                                            name={MATERIALS}
                                            value={index + 5}
                                            key={"area0_" + index}>
                                            {area}
                                        </Checkbox>
                                    )}
                                </Col>
                                <Col sm={3}>
                                    {Api.getWorkAreas().slice(8).map((area, index) =>
                                        <Checkbox
                                            name={MATERIALS}
                                            value={index + 9}
                                            key={"area0_" + index}>
                                            {area}
                                        </Checkbox>
                                    )}
                                </Col>
                            </Row>
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col sm={12}>
                            <input className="Button" type="submit" ref={input => this.inputElement = input} value="Zoeken" />
                        </Col>
                    </FormGroup>
                </Form>

                <div className="BedrijvenSearchResults" style={{ display: this.state.displayTable }}>
                    <Tabs defaultActiveKey={1} id="uncontrolled-tab-example">
                        <Tab eventKey={1} title="Overzicht">
                            <BedrijvenSearchResultTable companies={this.state.companies} parent={this.state} pagination={this.state.pagination} fnc={this.handleClick} fnc2={this.handleSortingClick} />
                        </Tab>
                        <Tab eventKey={2} title="Google Maps">
                            <BedrijvenSearchResultGoogleMaps companies={this.state.locations} />
                        </Tab>
                    </Tabs>
                </div>
                <div style={{ display: this.state.emptyTable }}>
                    <br /> <br />
                    Er zijn geen gegevens beschikbaar
                </div>
            </div>
        );
    }
}

export default BedrijvenSearch;


// WEBPACK FOOTER //
// ./src/components/Global/Modules/BedrijvenSearch.js